import React from 'react';
import { Image, Rect } from 'react-konva';
import { isMobilePhone/*, isMobileTablet*/,  screenCanShowModal } from '../../library/calc';
import {  } from '../../library/constants';

export class ResolveWarning extends React.Component {

  render() {

      let killToolTip = false;

      let {
        ptc,
        prc,
        left,
        top,
        cursorBecomesMove,
        cursorBecomesPointer,
        waringImage,
        nodeObjs,
        n,
        // nm,
        fn,
        fetchResolveAndPopModal,
        showToolTipFor,
        hideToolTip,
        isPedigree,
        pedigreeIsTall,
      } = this.props;


    if(n < 0) return null;

    let content = null;

    const potentialParentConflict = () =>{
      return typeof(ptc) !== 'undefined' && typeof(prc) === 'undefined'
    }

    const potentialPartnerConflict = () =>{
      return typeof(ptc) === 'undefined' && typeof(prc) !== 'undefined'
    }

    const potentialBothConflict = () =>{
      return typeof(ptc) !== 'undefined' && typeof(prc) !== 'undefined'
    }

    if(potentialParentConflict()){
      content = `{profile} has multiple sets of parents. Either edit to set one as adoptive/foster or click this icon to merge duplicates.`;
    } else if (potentialPartnerConflict()) {
      content = `{profile} may have duplicate partners. Click this icon to merge duplicates.`;
    } else if (potentialBothConflict()){
      content = `{profile} has multiple sets of parents and may have duplicate partners. Click this icon to merge duplicates.`;
    }

    left += -4;
    const pedigreeTop = ( pedigreeIsTall ? 16: 7.4);
    top += ( !isPedigree ? 24: pedigreeTop);

    return <Image
      image={waringImage}
      x={left}
      y={top}
      scaleX={.1}
      scaleY={.1}
      width={9 * 10}
      height={8 *  10}
      onTouchStart={(e)=>{
      }}

      onClick={()=>{
        if(isMobilePhone() ) return;
        killToolTip = true;
        fetchResolveAndPopModal({prId:nodeObjs[n].pr_id});
      }}

      onMouseover={()=>{
        cursorBecomesPointer();
        if(!killToolTip) {

          let shift = {};

          if(!isPedigree){
            shift = {
              left: -5,
              top: 0,
            }
          } else {
            if(pedigreeIsTall){
              shift = {
                left: -5,
                top: -9,
              }
            } else {
              shift = {
                left: -5,
                top: -13,
              }
            }
          }


          showToolTipFor({
            node: n,
            placement: 'under',
            shiftLeftOnToolTip: shift.left,
            shiftTopOnToolTip: shift.top,
            content,
            runTranslatePhraseInToolTip: true,
            translateVarStrInToolTip: fn,
          })
        }
      }}
      onMouseout={()=>{
        hideToolTip();
        cursorBecomesMove();
      }}


    />;
  }
}



export class TransparentResolveWarning extends React.Component {

  render () {

    let killToolTip = false;

    let {
      n,
      nodeObjs,
      left,
      top,
      userTouchedNode,
      fetchResolveAndPopModal,
      isPedigree,
      pedigreeIsTall,
      cursorBecomesMove,
      cursorBecomesPointer,
      showToolTipFor,
      hideToolTip,
      fn,
      ptc,
      prc,
    } = this.props;

    let content = null;

    const potentialParentConflict = () =>{
      return typeof(ptc) !== 'undefined' && typeof(prc) === 'undefined'
    }

    const potentialPartnerConflict = () =>{
      return typeof(ptc) === 'undefined' && typeof(prc) !== 'undefined'
    }

    const potentialBothConflict = () =>{
      return typeof(ptc) !== 'undefined' && typeof(prc) !== 'undefined'
    }

    if(potentialParentConflict()){
      content = `{profile} has multiple sets of parents. Either edit to set one as adoptive/foster or click this icon to merge duplicates.`;
    } else if (potentialPartnerConflict()) {
      content = `{profile} may have duplicate partners. Click this icon to merge duplicates.`;
    } else if (potentialBothConflict()){
      content = `{profile} has multiple sets of parents and may have duplicate partners. Click this icon to merge duplicates.`;
    }

    if(n < 0) return null;

    left += -4;

    const pedigreeTop = ( pedigreeIsTall ? 16: 10);
    top += ( !isPedigree ? 24: pedigreeTop);
/*
              fill="black"
              opacity=".4"

 */
    return  <Rect
              x={left}
              y={top}
              width={10}
              height={10}

              onClick={()=>{
                killToolTip = true;
                fetchResolveAndPopModal({prId:nodeObjs[n].pr_id});
              }}

              onMouseover={()=>{
                cursorBecomesPointer();
                if(!killToolTip) {

                  let shift = {};

                  if(!isPedigree){
                    shift = {
                      left: -5,
                      top: 0,
                    }
                  } else {
                    if(pedigreeIsTall){
                      shift = {
                        left: -5,
                        top: -9,
                      }
                    } else {
                      shift = {
                        left: -5,
                        top: -13,
                      }
                    }
                  }


                  showToolTipFor({
                    node: n,
                    placement: 'under',
                    shiftLeftOnToolTip: shift.left,
                    shiftTopOnToolTip: shift.top,
                    content,
                    runTranslatePhraseInToolTip: true,
                    translateVarStrInToolTip: fn,
                  })
                }
              }}
              onMouseout={()=>{
                hideToolTip();
                cursorBecomesMove();
              }}

              onTouchStart={()=>{
                userTouchedNode({
                  node:n,
                  callback: ()=>{
                    if(screenCanShowModal({minWidth:900})) {
                      fetchResolveAndPopModal({prId:nodeObjs[n].pr_id});
                    }
                  },
                  fromWhere: 'TransparentResolveWarning'
                });
              }}

            />

  }
}
